import { Box, IconButton } from '@mui/material';
import React from 'react';
import { useTheme } from "../../context/ThemeProvider";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

function ThemeToggle() {
  const [ThemeMode, toggleTheme] = useTheme();
  return (
    <Box onClick={toggleTheme} mode={ThemeMode} sx={{ p: 2, cursor: 'pointer', ml: { lg: 6, md: 3 } }}>
      {ThemeMode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
    </Box>
  );
}

export default ThemeToggle;
